const user = [{
  path: 'userPersonInfo',
  component: resolve => require(['../../../components/user/PersonInfo'], resolve)
}, {
  path: 'userModifyPassword',
  component: resolve => require(['../../../components/user/ModifyPassword'], resolve)
}, {
  path: 'userLoginHistory',
  component: resolve => require(['../../../components/user/LoginHistory'], resolve)
}, {
  path: 'userSettingInfo',
  component: resolve => require(['../../../components/user/SettingInfo'], resolve)
}, {
  path: 'userSecurityInfo',
  component: resolve => require(['../../../components/user/SecurityInfo'], resolve)
}]

export default user
